import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function PenIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M16.945 3.37c.588-.587.881-.88 1.207-1.021.468-.202 1-.202 1.468 0 .325.14.62.434 1.206 1.021.588.588.881.881 1.022 1.207.202.468.202 1 0 1.468-.14.325-.434.62-1.022 1.206l-5.021 5.022c-1.237 1.237-1.856 1.856-2.63 2.222-.776.367-1.646.453-3.387.625L9 15.197l.077-.788c.172-1.741.258-2.612.625-3.386.366-.775.985-1.394 2.222-2.631l5.021-5.022Z" />
      <path d="M6 15.197H3.75a1.75 1.75 0 1 0 0 3.5h9.5a1.75 1.75 0 1 1 0 3.5H11" />
    </SvgIcon>
  );
}
